<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="商品详情"> </el-page-header>
    <el-divider class="detail-divider"></el-divider>
    <el-tabs model-value="first">
      <el-tab-pane label="基础信息" name="first">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="商品编码" class="detail-form-item" prop="code">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="商品名称" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="商品分类" class="detail-form-item" prop="categoryId">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.categoryId">
                        <el-option v-for="item in productCategoryList" :key="item.id" :value="item.id" :label="item.name">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="商品分类标签" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.categoryTagId">
                        <el-option v-for="item in productCategorys" :key="item.id" :value="item.id" :label="item.name">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="平台状态" class="detail-form-item">
                      <el-input size="medium" v-model="entity.platformState"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="商品状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="排序号" class="detail-form-item">
                      <el-input-number size="medium" v-model="entity.sortNo"></el-input-number>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="CAS" class="detail-form-item">
                      <el-input size="medium" v-model="entity.cas"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="平台价格" class="detail-form-item">
                      <el-input size="medium" v-model="entity.platformPrice"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="销售价格" class="detail-form-item" prop="salePrice">
                      <el-input size="medium" v-model="entity.salePrice"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="物流方式" class="detail-form-item">
                      <el-input size="medium" v-model="entity.logistics"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="有效期" class="detail-form-item">
                      <el-input size="medium" v-model="entity.validityDate"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="规格" class="detail-form-item">
                      <el-input size="medium" v-model="entity.spec"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="标称值" class="detail-form-item">
                      <el-input size="medium" v-model="entity.nominal"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="储存条件" class="detail-form-item">
                      <el-input size="medium" v-model="entity.store"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="英文名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.englishName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="应用领域" class="detail-form-item">
                      <el-input size="medium" v-model="entity.domain"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="使用注意事项" class="detail-form-item">
                      <el-input size="medium" v-model="entity.notes"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="特征形态" class="detail-form-item">
                      <el-input size="medium" v-model="entity.feature"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="基体" class="detail-form-item">
                      <el-input size="medium" v-model="entity.matrix"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="主要分析方法" class="detail-form-item">
                      <el-input size="medium" v-model="entity.method"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="定值单位" class="detail-form-item">
                      <el-input size="medium" v-model="entity.constantUnit"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="商品标签" class="detail-form-item">
                      <el-select-v2 :key="refreshKey" ref="selTags" size="medium" v-model="tagValues" :options="tagOptions" clearable multiple style="width:100%" />
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="商品图片" name="second">
        <div class="detail-containe-product">
          <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="商品缩略图">
                  <el-upload class="avatar-uploader" action="customize" :auto-upload="true" :show-file-list="false" :http-request="uploadFile">
                    <img v-if="entity.img" :src="entity.img" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="商品详情" name="three">
        <div class="detail-containe-product">
          <el-form class="detail-form" ref="fromEditor" :model="entity" label-width="80px">
            <el-row :gutter="20" style="margin-bottom:0px">
              <el-col :span="6">
                <el-form-item label="详情页面">
                  <el-radio-group v-model="defaultProperty" size="small" @change="setEditorContent">
                    <el-radio-button v-for="item in entity.productPropertys" :key="item.name" :label="item.name">{{item.label}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="grid-content">
                  <TinymceEditor ref="editor"></TinymceEditor>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="量值信息" name="four">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-table :data="entity.productQuantitys" border style="width: 100%">
              <el-table-column prop="no" label="序号" width="50"> </el-table-column>
              <el-table-column prop="name" label="名称" width="200"> </el-table-column>
              <el-table-column prop="standard" label="标准值" width="200"> </el-table-column>
              <el-table-column prop="offset" label="标准偏差(S)" width="100"> </el-table-column>
              <el-table-column prop="unit" label="单位" width="200"> </el-table-column>
              <el-table-column prop="cas" label="CAS" width="100"> </el-table-column>
              <el-table-column prop="remark" label="备注"> </el-table-column>
              <el-table-column label="操作" width="200">
                <template #default="scope">
                  <el-button size="mini" type="danger" @click="deleteRow(scope)">删行</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Product,
  ProductCategory,
  ProductProperty,
} from "@/script/apps/shop/entity/ShopEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ProductService } from "@/script/apps/shop/service/ProductService";
import { ProductCategoryService } from "@/script/apps/shop/service/ProductCategoryService";
import { ElMessage } from "element-plus";
import { AppConfig } from "@/script/core/base/AppConfig";
import { TagService } from "@/script/apps/cms/service/TagService";
import { Tag } from "@/script/apps/cms/entity/CmsEntity";
import { Dict } from "@/script/apps/system/entity/SystemEntity";
import TinymceEditor from "@/components/TinymceEditor.vue";

@Options({
  components: {
    TinymceEditor,
  },
})
export default class ProductDetail extends BaseDetail {
  private refreshKey = 1;

  private tagValues: number[] = [];

  private tagOptions: any[] = [];

  protected productCategorys: Tag[] = [];

  private productCategoryList: ProductCategory[] = [];

  private productService = new ProductService();

  public defaultProperty = "describe";
  private preProperty = "";

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_shop_product",
      "/shop/product",
      "/shop/product",
      this.productService
    );
    data.statesName = "product-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    salePrice: [{ required: true, message: "请输入销售价格", trigger: "blur" }],
    categoryId: [
      { required: true, message: "请选择商品分类", trigger: "change" },
    ],
  };

  activated() {
    // 强制刷新组件
    this.refreshKey += 1;
    this.tagValues = [];
  }

  public newEntity() {
    const entity: Product = {};

    entity.productPropertys = [];
    entity.productPropertys.push({
      type: "text",
      name: "describe",
      label: "产品描述",
      content: "",
    });
    entity.productPropertys.push({
      type: "text",
      name: "parameter",
      label: "产品参数",
      content: "",
    });
    entity.productPropertys.push({
      type: "text",
      name: "video",
      label: "产品视频",
      content: "",
    });
    this.setEditorContent("describe");
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    const productCategoryService = new ProductCategoryService();
    productCategoryService.loadProductCategorys((data: any) => {
      this.productCategoryList = data;
    });

    const tagService = new TagService();
    tagService.loadTagsByType("product", (data: any) => {
      const tags: Tag[] = data;
      this.tagOptions = [];
      tags.forEach((item) => {
        this.tagOptions.push({
          value: item.id,
          label: item.name,
        });
      });
    });

    tagService.loadTagsByType("productCategory", (data: any) => {
      this.productCategorys = data;
    });
  }

  public afterLoad() {
    const product = this.entity as Product;
    product.deleteProductQuantitys = [];
    this.injectDetailData(
      product.productQuantitys!,
      product.deleteProductQuantitys!
    );
    this.generateRowNo();

    if (product.tagIds) {
      const tempTagValues: number[] = [];
      const stagIds = product.tagIds?.split(",");
      stagIds.forEach((item) => {
        tempTagValues.push(Number(item));
      });
      this.tagValues = tempTagValues;
    } else {
      this.tagValues = [];
    }
  }

  public beforeSave() {
    this.entity.tagIds = this.tagValues?.join(",");
    return true;
  }

  uploadFile(param: any) {
    const path = "shop";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.productService.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${param.file.name}`;
        this.entity.img = uploadUrl;
      },
      (error: Error) => {
        ElMessage.error("上传图片失败！原因：" + error);
      }
    );
  }

  private getProperty(name: string): ProductProperty | null {
    let result: ProductProperty | null = null;
    const product = this.entity as Product;
    product.productPropertys!.forEach((item) => {
      if (item.name === name) {
        result = item;
      }
    });
    return result;
  }

  setEditorContent(name: string) {
    if (this.$refs.editor) {
      const property = this.getProperty(name);
      if (property) {
        if (this.preProperty !== "") {
          const prePropertyContent = this.getProperty(this.preProperty);
          prePropertyContent!.content = (
            this.$refs.editor as TinymceEditor
          ).getContent();
        }
        (this.$refs.editor as TinymceEditor).setContent(property.content);        
        this.preProperty = name;
      }
    }
  }
}
</script>

<style lang="scss">
</style>
